const reviews = [
  {
    name: 'Andrew Richards',
    initial: 'A',
    text: 'Just want to say how simple it was getting the electrics tested in the property I was purchasing. Kevin got in touch with me and confirmed everything such as dates and timescales for the report. He then sent the report over very quickly. Nice that he took the time to message me a few days later to check that I didn\'t have any questions. Would recommend',
  },
  {
    name: 'Lynela W',
    initial: 'L',
    text: 'At last, a tradesman who turns up when he says he will, and does a really good job at a reasonable price. Very nice guy too. 100% recommend.',
  },
  {
    name: 'Judith L',
    initial: 'J',
    text: 'Connected via Facebook, great service from start to finish, kept me informed of what was happening as had to wait for part, friendly guy, will use again if needed',
  },
  {
    name: 'Mark Davies',
    initial: 'M',
    text: 'Brilliant service from start to finish. Kevin was professional, punctual and very knowledgeable. Rewired our entire house and the finish was immaculate. Highly recommend Megalec to anyone in South Wales.',
  },
  {
    name: 'Sarah Thomas',
    initial: 'S',
    text: 'Called for an emergency and Kevin was there within the hour. Fixed the issue quickly and explained everything clearly. Fair pricing and top quality work. Will definitely use again.',
  },
  {
    name: 'James Morgan',
    initial: 'J',
    text: 'Had a consumer unit upgrade done by Megalec. Kevin was very thorough, tidy and completed the work to a very high standard. Great communication throughout. Wouldn\'t hesitate to recommend.',
  },
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-google-fill text-4xl text-secondary"></i>
            <span className="text-lg font-semibold text-secondary">Google Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4 font-display">
            What Our Customers Say
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
            ))}
          </div>
          <p className="text-gray-600 font-semibold">5.0 Star Rating on Google</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <i className="ri-google-fill text-xl text-gray-400"></i>
              </div>
              <p className="text-gray-700 text-sm mb-4 leading-relaxed">{review.text}</p>
              <div className="flex items-center">
                <div className="w-10 h-10 flex items-center justify-center bg-primary rounded-full mr-3">
                  <span className="text-white font-bold text-sm">{review.initial}</span>
                </div>
                <div>
                  <p className="font-bold text-secondary text-sm">{review.name}</p>
                  <p className="text-gray-400 text-xs">Google Review</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
